import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useGetAllProjectsQuery } from "../../redux/projectApi";
import { useDebounce } from "use-debounce";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const Projects = () => {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [debouncedSearch] = useDebounce(search, 1500);

  const handlePrev = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  const handleNext = () => {
    if (page < data?.totalPages) setPage((prev) => prev + 1);
  };

  const { data, error, isLoading } = useGetAllProjectsQuery({
    page,
    search: debouncedSearch,
  });

  const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) {
      return text;
    }
    return text.slice(0, maxLength) + "...";
  };

  return (
    <div className="flex flex-col lg:gap-10 md:gap-6 gap-4 bg-white rounded-xl lg:p-4 p-3 h-full">
      <div className="flex justify-between items-center">
        <p className="text-[#05004E] font-semibold lg:text-[1.8rem] md:text-[1.4rem] text-[1.2rem]">
          Projects
        </p>
        <div className="flex  items-center">
          <NavLink
            to={"/projects/add-project"}
            className="lg:w-[12rem] md:w-[10rem] w-max bg-[#00643b] text-center lg:py-3 md:py-2 md:px-0 px-2 py-1.5 lg:text-[1rem] md:text-[.9rem] text-[.75rem] md:rounded-xl rounded-lg font-medium text-white"
          >
            + Add New Project
          </NavLink>
        </div>
      </div>
      <div className=" flex flex-col gap-4 w-full">
        <div className=" flex justify-end w-full">
          <input
            type="search"
            placeholder="Search by title..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setPage(1);
            }}
            className="border-2 rounded-xl border-[#05004e40] md:p-3 p-2 outline-none md:w-[24rem] md:text-[1rem] text-[.8rem] w-[18rem]"
          />
        </div>
        {isLoading ? (
          <div className="grid xl:grid-cols-4 lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-3 ">
            <div className=" bg-[#EFEFEF] animate-pulse aspect-[1/1.2] rounded-2xl"></div>
            <div className=" bg-[#EFEFEF] animate-pulse aspect-[1/1.2] rounded-2xl"></div>
            <div className=" bg-[#EFEFEF] animate-pulse aspect-[1/1.2] rounded-2xl"></div>
            <div className=" bg-[#EFEFEF] animate-pulse aspect-[1/1.2] rounded-2xl"></div>
            <div className=" bg-[#EFEFEF] animate-pulse aspect-[1/1.2] rounded-2xl"></div>
            <div className=" bg-[#EFEFEF] animate-pulse aspect-[1/1.2] rounded-2xl"></div>
            <div className=" bg-[#EFEFEF] animate-pulse aspect-[1/1.2] rounded-2xl"></div>
            <div className=" bg-[#EFEFEF] animate-pulse aspect-[1/1.2] rounded-2xl"></div>
            <div className=" bg-[#EFEFEF] animate-pulse aspect-[1/1.2] rounded-2xl"></div>
            <div className=" bg-[#EFEFEF] animate-pulse aspect-[1/1.2] rounded-2xl"></div>
          </div>
        ) : (
          data && (
            <>
              {data?.totalPages === 0 ? (
                <div className=" text-center w-full lg:text-[3rem] md:text-[2rem] text-[1.4rem] font-semibold text-[#05004E]">
                  No Project Found
                </div>
              ) : (
                <div className=" grid xl:grid-cols-4 lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-3">
                  {data?.projects?.map((project) => (
                    <NavLink
                      to={`/projects/update-project/${project?._id}`}
                      key={project._id}
                      className=" bg-[#DEE9E4] p-4 w-full rounded-2xl flex flex-col gap-2"
                    >
                      <img
                        src={project?.coverImage?.imageUrl}
                        className=" rounded-lg w-full"
                        alt=""
                      />
                      <div>
                        <h1 className="font-medium">{project?.title}</h1>
                        <p className=" text-sm">
                          {truncateText(project?.content, 20)}
                        </p>
                      </div>
                    </NavLink>
                  ))}
                </div>
              )}
              <div className=" flex justify-between items-center">
                <div className=" text-[#0000004f]">
                  Showing record page {data?.currentPage} 0f {data?.totalPages}
                </div>
                <div className=" flex items-center gap-4">
                  <div
                    onClick={handlePrev}
                    disabled={page === 1}
                    className={`bg-[#02643B1F] p-2 text-[#00643b] rounded-xl ${
                      page === 1
                        ? " cursor-not-allowed opacity-50"
                        : "cursor-pointer"
                    }`}
                  >
                    <IoIosArrowBack className="size-6" />
                  </div>
                  {data?.currentPage}
                  <div
                    onClick={handleNext}
                    disabled={page === data?.totalPages}
                    className={`bg-[#02643B1F] p-2 text-[#00643b] rounded-xl ${
                      page === data?.totalPages
                        ? " cursor-not-allowed opacity-50"
                        : "cursor-pointer"
                    }`}
                  >
                    <IoIosArrowForward className="size-6" />
                  </div>
                </div>
              </div>
            </>
          )
        )}{" "}
      </div>
      {error && (
        <p className=" text-red-500 text-center md:text-[1rem] text-sm bg-red-100 p-2 rounded-lg">
          {error?.data?.message}
        </p>
      )}
    </div>
  );
};

export default Projects;
